import { useAppSelector } from '@/redux/hooks'
import {
  HorizontalBanner,
  VerticalBanner
} from './landing-components/landing-banner'
import { VerticalForm, HorizontalForm } from './landing-components/landing-form'
import { SimplifiedLanding } from './landing-components/simplified-landing'
import { PoweredByRever } from '@itsrever/design-system'
import { usePreviewDevice } from '@/ui/components/portal-preview/use-portal-branding'

function PortalLandingPage() {
  const settings = useAppSelector(
    (store) => store.settingsApi.settings.response
  )
  const design = settings.theme?.design
  // The rounding stands in for the phone's screen corners; a browser window has none.
  const rounded = usePreviewDevice() === 'desktop' ? '' : 'rounded-[35px]'

  return (
    <>
      <div
        className={`flex size-full grow flex-col items-center bg-white ${rounded}`}
      >
        <>
          {design === 'VERTICAL' ? (
            <div className="w-full grow">
              <VerticalBanner />
              <VerticalForm />
            </div>
          ) : design === 'SIMPLIFIED' ? (
            <div className="grow">
              <SimplifiedLanding />
            </div>
          ) : (
            <div
              className={`flex size-full grow flex-col items-center bg-white ${rounded}`}
            >
              <HorizontalBanner />
              <HorizontalForm />
            </div>
          )}
        </>
        {design === 'SIMPLIFIED' ||
        design === 'DEFAULT' ||
        design === undefined ? (
          <div>
            <div className="flex w-full items-center justify-center py-4">
              <PoweredByRever />
            </div>
          </div>
        ) : null}
      </div>
    </>
  )
}

export default PortalLandingPage
